export default class Cart {
  static async get() {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await res.json();

    return cart;
  }

  static async add(id, options = {}) {
    const formData = {
      items: [
        {
          id,
          ...options,
        },
      ],
    };

    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const { items } = await res.json();

    return items;
  }

  static async update(options = {}) {
    const formData = {
      updates: options,
    };

    const res = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const cart = await res.json();
    return cart;
  }
}
